import "./runtimeEnvironment-aTp6aZUT.mjs";
import { deprecated, deprecatedObjectProperty, deprecatedProperty } from "./deprecated-CFM4jPRM.mjs";

export { deprecated, deprecatedObjectProperty, deprecatedProperty };